module.exports = __webpack_public_path__ + "static/media/personal_media_carousel.41eb00aa.xlsx";